<template>
<div>
<div v-if="isWIP" @click="doEmit" class="tooltip" @mouseover="onMouseHandler">
    <img class="imgLink" :src="require('@/assets/wip2.png')" title="Probiha spracovani" />    
</div>
<div v-else-if="!isWIP && hasImg" @click="fetchScreenshot">
    <img class="imgLink" :src="require('@/assets/v2e.png')" title="Zobraz MyWay obrazovku" />
</div>
<div v-else>
    <span>{{ action }}</span>
</div>

  <!-- Modal -->
  <div v-if="showModal" class="modal" @click="closeModal" @keydown="handleKeydown">
    <div class="modal-content-wrapper" :class="{ 'zoomed': isZoomed }">
      <span class="close-btn" @click="closeModal">&times;</span>
      <!-- 🚥 change start here -->
      <div v-if="screenshotUnavailable" class="screenshot-unavailable">
        <div class="unavailable-message">
          <h3>Obrazek z MyWay neni k dispozici</h3>
          <p>Screenshot byl smazán nebo není dostupný.</p>
        </div>
      </div>
      <div v-else>
        <div class="zoom-indicator" v-if="!isZoomed">Click image to zoom</div>
        <div class="zoom-indicator zoomed-indicator" v-else>Click image to unzoom</div>
        <img 
          :src="imageUrl" 
          alt="Screenshot Image" 
          class="modal-content" 
          :class="{ 'zoomed': isZoomed }"
          @click.stop="toggleZoom"
        />
      </div>
    </div>
  </div>

</div>
</template>


<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import axios from "@/services/axios-common";

export default {
    props: {
        id: {
            type: Number,
            default: 0,
            required: true
        },
        trnID: {
            type: Number,
            default: 0,
            required: true
        },
        imgLink: {
            type: [String, null],
            default: "",
            required: true,
        },
        action: {
            type: [String, null],
            default: null,
            required: false
        },
        data: { // db row with all columns
            type: [Object, null],
            default: null,
            required: false
        }
    },
    emits: ['img-link-show-log', 'img-link'],

    setup(props, { emit }) {
        // Reactive data - convert from data() function
        const ctrlKeyStatus = ref(false)
        const showModal = ref(false)
        const imageUrl = ref('')
        const isZoomed = ref(false)
        const screenshotUnavailable = ref(false)

        // Computed properties - convert from computed object
        const hasImg = computed(() => {
            console.log('imgLink value:', props.imgLink, typeof props.imgLink);
            return props.imgLink === null ? false : props.imgLink > '';
        });
        const isWIP = computed(() => {
            //console.log('ret isWIP', props.action, props.action==='WIP')
            return props.action === 'WIP'
        });
        const showLog = computed(() => isWIP.value && ctrlKeyStatus.value);
        const showUnavailablePopup = () => {
          screenshotUnavailable.value = true;
          showModal.value = true;
        }

        // Methods - convert to regular functions
        const fetchScreenshot = async () => {
            try {
                // Using axios with dynamic API_URL from axios-common.js
                const response = await axios.get(`/worker/screenshot/${props.trnID}`, {
                    responseType: 'blob' // Important for binary image data
                })
                const respAsTxt = await response.data.text();
                let respJson;
                try { respJson = JSON.parse(respAsTxt); } catch(e){ respJson=null; }
                if (respJson && respJson.error === 'screenshot-not-available') {
                    showUnavailablePopup();
                    return;
                }
               // console.log('##### response.data', response.data)
                // Create blob URL for the image
                imageUrl.value = URL.createObjectURL(response.data)
                console.log('##### imageUrl', imageUrl.value)
                showModal.value = true
                isZoomed.value = false // Reset zoom state when opening modal
            } catch (error) {
                console.error('Error fetching screenshot:', error)
                // You can add user-friendly error handling here if needed
            }
        }

        const closeModal = () => {
            showModal.value = false
            imageUrl.value = ''
            isZoomed.value = false
            screenshotUnavailable.value = false
        }

        const toggleZoom = () => {
            isZoomed.value = !isZoomed.value
        }

        const handleKeydown = (event) => {
            if (event.key === 'Escape') {
                if (isZoomed.value) {
                    // If zoomed, first unzoom
                    isZoomed.value = false
                } else {
                    // If not zoomed, close modal
                    closeModal()
                }
            }
        }

        const doEmit = () => {
            console.log('ImgLink doEmit', this)
            if(showLog.value) {
                emit('img-link-show-log', { id: props.id })
            } else {
                emit('img-link', { id: props.id, imgLink: props.imgLink, action: props.action })
            }
        }

        const onMouseHandler = (event) => {
            ctrlKeyStatus.value = event.ctrlKey
        }

        // Add/remove ESC key listener
        onMounted(() => {
            document.addEventListener('keydown', handleKeydown)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('keydown', handleKeydown)
        })

        return {
            ctrlKeyStatus,
            showModal,
            imageUrl,
            isZoomed,
            screenshotUnavailable,
            hasImg,
            isWIP,
            showLog,
            fetchScreenshot,
            closeModal,
            toggleZoom,
            handleKeydown,
            doEmit,
            onMouseHandler,
            showUnavailablePopup
        }
    }
}
</script>

<style scoped>
.imgLink{
    width: 25px;
    height: 25px;
    padding: 5px 5px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

.modal-content-wrapper {
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
}

.modal-content-wrapper.zoomed {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  color: #f1f1f1;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-content {
  max-width: 90vw;
  max-height: 90vh;
  cursor: pointer;
  transition: all 0.3s ease;
  object-fit: contain;
}

.modal-content.zoomed {
  width: 100vw !important;
  height: auto !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain; /* Changed from fill to contain to maintain aspect ratio */
  max-width: 100vw !important; /* Ensure image never exceeds viewport width */
}

.modal-content-wrapper.zoomed {
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: flex-start !important; /* Changed from center to flex-start */
  justify-content: center !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  background-color: rgba(0, 0, 0, 0.95) !important;
  overflow-y: auto !important; /* Enable vertical scrolling on wrapper */
  overflow-x: hidden !important; /* Completely hide horizontal scrollbar */
  padding: 20px 0; /* Add some padding for better UX */
  scrollbar-width: thin; /* Firefox: make scrollbar thinner */
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.3); /* Firefox: customize scrollbar colors */
}

.zoom-indicator {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0.9;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1000;
}

.zoomed-indicator {
  bottom: 20px;
  background: rgba(0, 0, 0, 0.9);
}

.modal-content-wrapper:hover .zoom-indicator {
  opacity: 1;
}

.modal-content-wrapper.zoomed .zoom-indicator {
  bottom: 20px;
}

/* Remove conflicting styles for image scrolling */
.modal-content.zoomed {
  /* Let the wrapper handle scrolling instead */
}

/* Enhanced modal background for zoomed state */
.modal.zoomed {
  background-color: rgba(0, 0, 0, 0.98) !important;
  overflow-x: hidden !important; /* Ensure modal itself doesn't allow horizontal scroll */
}

/* Smooth scrolling for better UX */
.modal-content-wrapper.zoomed {
  scroll-behavior: smooth;
}

/* Webkit scrollbar styling for Chrome/Safari/Edge */
.modal-content-wrapper.zoomed::-webkit-scrollbar {
  width: 8px; /* Thin scrollbar */
}

.modal-content-wrapper.zoomed::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.modal-content-wrapper.zoomed::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.modal-content-wrapper.zoomed::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Prevent any horizontal overflow from body when modal is open */
/* Prevent any horizontal overflow from body when modal is open */
body:has(.modal.zoomed) {
  overflow-x: hidden;
}

.screenshot-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  padding: 20px;
}
.unavailable-message h3 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #ff6b6b;
}
.unavailable-message p {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}
</style>